import { render, staticRenderFns } from "./plotsPage.html?vue&type=template&id=4a51a56b&"
import script from "./plotsPage.vue?vue&type=script&lang=js&"
export * from "./plotsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports